<template>
  <UAlert
    icon="i-lucide-book-open"
    :title="title"
    :description="description"
    :actions="actions"
    variant="subtle"
    :ui="{
      title: 'text-primary-900 dark:text-primary-200',
      description: 'text-primary-800 dark:text-primary-300',
    }"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getDocsUrl, type DocKey } from '@/utils/docs-links'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  docKey: {
    type: String as () => DocKey,
    required: true,
  },
  tenantDocKey: {
    type: String as () => DocKey,
    default: undefined,
  },
  linkLabel: {
    type: String,
    default: 'Zur Dokumentation',
  },
  tenantLinkLabel: {
    type: String,
    default: 'Zur Mandantenkonfiguration',
  },
})

const actions = computed(() => {
  const items = [
    {
      label: props.linkLabel,
      to: getDocsUrl(props.docKey),
      target: '_blank',
      color: 'primary',
    },
  ]

  if (props.tenantDocKey) {
    items.push({
      label: props.tenantLinkLabel,
      to: getDocsUrl(props.tenantDocKey),
      target: '_blank',
      color: 'primary',
    })
  }

  return items
})
</script>
